import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PermisoViaje } from 'src/app/modelos/permisoviaje';
import { PermisoViajeService } from 'src/app/services/permisoviaje.service';

@Component({
  selector: 'app-permiso-viaje-qr',
  templateUrl: './permiso-viaje-qr.component.html',
  styleUrls: ['./permiso-viaje-qr.component.css']
})
export class PermisoViajeQrComponent implements OnInit {

  TipoPermiso:string = '';
  padres:any;
  menores:any;
  permiso: PermisoViaje = new PermisoViaje();

  constructor(private rutaActiva: ActivatedRoute,private permisoViajeService:PermisoViajeService, private spinner: NgxSpinnerService) { }

  ngOnInit() {

    this.spinner.show();
    this.permisoViajeService.GetById(this.rutaActiva.snapshot.params.id).subscribe(response => {
      this.spinner.hide();
      this.permiso = response.permisos[0];

      this.TipoPermiso = this.permiso.tipoPermiso;

      this.padres = response.participantes.filter(function(item) {
        return item.idCondicion != 2;
      });
      
      this.menores = response.participantes.filter(function(item) {
        return item.idCondicion == 2;
      });
     
    });


  }

}
